var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card mb-4"},[_c('h5',{staticClass:"card-header"},[_vm._v("Attachments")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('AttachmentsList',{attrs:{"leadlike-id":_vm.leadQuoteOrder.id}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }